// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"a","newsroomBannerBox":"a","newsroomBannerLeft":"b","newsroomBannerRight":"c"};